import React from 'react';
import './FAQ.css';
import { trackFAQToggle } from '../services/trackingService';

/* Accessible FAQ section using <details>/<summary>. Anchor id="faq" for navigation. */

const faqData = [
  {
    q: "Comment financer une formation (CPF / OPCO / Pôle Emploi) ?",
    a: "Nous vous accompagnons pour mobiliser votre CPF, monter un dossier OPCO ou constituer une Aide Individuelle à la Formation via France Travail (ex Pôle Emploi). Contactez-nous pour un diagnostic gratuit sous 24h."
  },
  {
    q: "Proposez-vous des cours à distance ?",
    a: "Oui, toutes nos formations sont disponibles en présentiel, distanciel synchrone (visioconférence) ou format hybride, selon vos contraintes."
  },
  {
    q: "Quelles certifications sont préparées ?",
    a: "Nous préparons et faisons passer les certifications LILATE et LEVELTEL alignées avec le CECRL (A1 à C2)."
  },
  {
    q: "Quel est le délai pour recevoir un devis ?",
    a: "Un devis personnalisé vous est envoyé en général sous 24 heures après analyse de vos besoins linguistiques."
  },
  {
    q: "Puis-je tester mon niveau avant d'engager une formation ?",
    a: "Oui, un test de positionnement et un entretien pédagogique vous sont proposés gratuitement afin de construire un parcours adapté."
  }
];

const FAQ = () => {
  return (
    <section id="faq" className="faq" aria-labelledby="faq-heading">
      <div className="container faq__inner">
        <h2 id="faq-heading" className="faq__heading">FAQ</h2>
        <ul className="faq__list">
          {faqData.map((item, idx) => (
            <li key={idx}>
              <details className="faq-item" onToggle={(e) => { if (e.target.open) trackFAQToggle(idx, item.q); }}>
                <summary>{item.q}</summary>
                <div className="faq-item__panel">
                  <p>{item.a}</p>
                </div>
              </details>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FAQ;
